import { cx } from '@linaria/core';
import { useRef } from 'react';
import { Chevron } from '@utils/react';
import { Checkmark } from './atom.checkmark.js';
import { imageWrapperCls, imageCls, badgeCls, headingCls, chevronCls, standaloneChevronWrapper, descriptionCls, checkmark, wrapperCls } from './lightbox.preview.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CardPreview(props) {
  const ref = useRef(null);
  return /*#__PURE__*/jsxs("button", {
    ref: ref,
    onClick: props.onClick,
    "aria-label": `Aktiver ${props.title ?? "iframe"}`,
    className: cx(wrapperCls, props.hasShared && "hasShared"),
    children: [/*#__PURE__*/jsxs("div", {
      className: imageWrapperCls,
      children: [/*#__PURE__*/jsx("img", {
        className: imageCls,
        src: props.previewImageSrc,
        alt: "",
        role: "presentation"
      }), props.indexOrLevel && /*#__PURE__*/jsx("span", {
        className: cx(badgeCls, props.audience),
        children: props.indexOrLevel
      })]
    }), props.title ? /*#__PURE__*/jsxs("h3", {
      className: headingCls,
      children: [/*#__PURE__*/jsx("span", {
        className: chevronCls,
        children: /*#__PURE__*/jsx(Chevron, {
          size: 10,
          lineWidth: 2
        })
      }), props.title.length > 40 ? props.title?.trim().substring(0, 38).trim() + "…" : props.title]
    }) : /*#__PURE__*/jsxs("div", {
      className: standaloneChevronWrapper,
      children: [/*#__PURE__*/jsx("span", {
        className: cx(chevronCls, "standalone"),
        children: /*#__PURE__*/jsx(Chevron, {
          size: 10,
          lineWidth: 2
        })
      }), props.hasShared && /*#__PURE__*/jsx(Checkmark, {})]
    }), props.description && /*#__PURE__*/jsx("span", {
      className: descriptionCls,
      children: props.description.length > 100 ? props.description?.trim().substring(0, 98).trim() + "…" : props.description
    }), props.hasShared && props.title && /*#__PURE__*/jsx(Checkmark, {
      className: checkmark
    })]
  });
}

export { CardPreview };
//# sourceMappingURL=lightbox.preview.js.map
